import React, { createContext, useContext, useEffect, useState } from "react";
import { apiClient } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = loading, false = anonymous, object = authenticated admin
    const [user, setUser] = useState(null);

    useEffect(() => {
        let mounted = true;
        apiClient
            .get("/auth/me")
            .then((res) => {
                if (mounted) setUser(res.data);
            })
            .catch(() => {
                if (mounted) setUser(false);
            });
        return () => {
            mounted = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await apiClient.post("/auth/login", { email, password });
        if (data?.access_token) {
            localStorage.setItem("dic_access_token", data.access_token);
        }
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await apiClient.post("/auth/logout");
        } catch (e) {
            // ignore
        }
        localStorage.removeItem("dic_access_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
